<template>

    <div>
        <div class="container " style="padding-top:70px;">
            <div class="row">
                <div class="col-sm-2"  v-if="webW">
                    <div   id="JfLeftMenuOut">
                        <div :class="(fixedleftmenu?'fixedJfLeftMenu':'')"   :style="fixedleftmenu?('width:'+LeftMenuWidth+'px'):''"  id="JfLeftMenu" >

                                <MySet></MySet>


                        </div>
                        <div v-if="fixedleftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                    </div>
                </div>
                <div :class="(webW?'col-sm-10':'col-sm-12')">
                    <div>
                        <el-card class="box-card " >
                            <div slot="header" class="tishi"  >
                                <span>上传头像</span>

                            </div>
                            <div style="text-align: center;">
                                <el-upload
                                        list-type="fileList"
                                        drag
                                        :before-upload="beforeUploadFileTX"
                                        :show-file-list="false"
                                        :action=FILE_ACTIONTX
                                        :on-success="handleFileSuccessTX"
                                        accept="image/*"
                                        :multiple="false">

                                    <img :src="faceimg" style="width: 100px;height: 100px;border-radius:5%">
                                    <p  style="font-size: 12px;color: #888888;">支持拖拽上传</p>
                                </el-upload>
                                <p style="font-size: 15px;color: #888888;">图片大小2M以内</p>

                            </div>




                        </el-card>

                        <br>


                        <el-card class="box-card">
                            <div slot="header" class="tishi">
                                <span>编辑资料</span>

                            </div>
                            <div>
                                <el-form
                                        label-width="0px"
                                        :model="dataFormR"
                                        :rules="dataFormRRule"
                                        ref="dataFormR"
                                >
                                    <el-form-item  prop="uname">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input   :disabled="canEditUname==1?false:true"  placeholder="请输入用户名"  v-model="dataFormR.uname"   >
                                                    <template #prepend>
                                                        用户名
                                                    </template>
                                                    <template slot="append">
                                                        <el-button type="danger" :disabled="canEditUname==1?false:true" @click="saveEditR">确定修改
                                                        </el-button>
                                                    </template>
                                                </el-input>
                                            </div>

                                            <div class="col-sm-6">


                                                <span class="inptip">{{editUnameDay}}天可修改1次<span
                                                        v-if="canEditTs!=null">，下次修改时间{{canEditTs}}后</span><span
                                                        v-if="canEditUname==1">，现在可修改</span></span>
                                            </div>
                                        </div>


                                    </el-form-item>


                                </el-form>


                                <el-form
                                        label-width="0px"
                                        :model="dataForm"
                                        :rules="dataFormRule"
                                        ref="dataForm"
                                >


                                    <el-form-item prop="rname">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input   placeholder="请输入真实姓名" v-model="dataForm.rname"    >
                                                    <template #prepend>
                                                        真实姓名
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6">
                                                <span class="inptip">请输入汉字</span>
                                            </div>
                                        </div>
                                    </el-form-item>



                                    <el-form-item prop="mobile">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input placeholder="请输入手机" v-model="dataForm.mobile" class="input-with-select">

                                                    <el-select slot="prepend" v-model="dataForm.qcountryMobile" style="width: 100px;">
                                                        <el-option @click.native="selqcm(t)" v-for="(t,i) in qcountryMobileLi" :key="i" :label="t.name+t.value" :value="t.name+t.value"></el-option>

                                                    </el-select>


                                                </el-input>
                                            </div>
                                            <div class="col-sm-6"> <span class="inptip">请选择区号并输入手机号</span></div>
                                        </div>

                                    </el-form-item>


                                    <el-form-item   prop="address">

                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input   placeholder="请输入常住地址" v-model="dataForm.address"    >
                                                    <template #prepend>
                                                        常住地址
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6">
                                                <span class="inptip">200字以内</span>
                                            </div>
                                        </div>
                                    </el-form-item>

                                    <el-form-item>
                                        <p>上传个人近照</p>
                                        <el-upload
                                                list-type="fileList"
                                                drag
                                                :before-upload="beforeUploadFile"
                                                :show-file-list="false"
                                                :action=FILE_ACTION
                                                :on-success="handleFileSuccess"
                                                accept="image/*"
                                                :multiple="false">

                                            <img v-if="pimg!=''" :src="pimg" style="max-width: 100%;">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            <p style="font-size: 12px;color: #888888">支持拖拽上传,{{pimgSize}}M以内</p>
                                        </el-upload>
                                    </el-form-item>


                                </el-form>
                                <div >
                                    <el-button type="warning" round @click="saveEdit">
                                        保存数据
                                    </el-button>
                                </div>
                            </div>
                        </el-card>


                        <div class="h100"></div>

                    </div>
                </div>
            </div>






        </div>






    </div>



</template>
<script>


    import {editMyUinfo, getMyUserinfo, checkOne, editUname} from '../../../api';
    import {dealResult, qcountryMobileLi, pimgSize, getWindowWidth} from "../../../api/common";
    import {validateMobile, validateRealname, validateUname} from "../../../api/validator";

    import MySet from "./MySet";
    export default {
        name: "EditUinfo",
        components: {MySet},

        data() {
            const checkExistUname = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    checkOne({
                        name: 'uname',
                        value: str,
                        uid: this.lander.uid,
                        token: this.lander.token
                    }).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            const checkExistMobile = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    checkOne({
                        name: 'mobile',
                        value: str,
                        uid: this.lander.uid,
                        token: this.lander.token
                    }).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            return {
                fixedleftmenu:false,
                LeftMenuWidth:0,

                webW:true,

                faceimg:'',
                FILE_ACTIONTX:'',

                pimgSize: 0,
                canEditTs: '',
                canEditUname: '',
                editUnameDay: '',

                FILE_ACTION: '',
                qcountryMobileLi: [],


                pimg: '',
                lander: {},
                obj: {},

                dataForm: {

                    rname: "",
                    mobile: "",
                    qcountryMobile: "",
                    countryMobile: "",
                    quhaoMobile: "",
                    address: "",


                },
                dataFormRule: {


                    rname: [{required: true, message: "请输入姓名", trigger: "blur"},
                        {validator: validateRealname, trigger: "blur"}],
                    mobile: [{required: true, message: "请输入手机号", trigger: "blur"},
                        {validator: validateMobile, trigger: "blur"},
                        {validator: checkExistMobile, trigger: "blur"}],
                    qcountryMobile: [{required: true, message: "请选择区号", trigger: "blur"}],


                },

                dataFormR: {uname: ''},
                dataFormRRule: {
                    uname: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                        {validator: validateUname, trigger: "blur"},
                        {validator: checkExistUname, trigger: "blur"}
                    ]
                },

            };
        },
        methods: {
            beforeUploadFileTX(file){
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                    return isLt2M;
                }

                this.loading = this.$loading({
                    lock: true,
                    text: "上传中，请稍等,,,,",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
            },
            handleFileSuccessTX(res) {
                this.loading.close();
                dealResult(res);
                if( res.status==1){

                    this.$message.success( '上传成功' );
                    this.faceimg=res.obj;

                    this.$store.dispatch('saveFaceimg',res.obj);
                }else{
                    this.$message.error(res.msg);
                }

            },

            selqcm(t) {
                console.log(t)
                this.dataForm.countryMobile = t.name;
                this.dataForm.quhaoMobile = t.value;
            },

            beforeUploadFile(file) {
                const isLt2M = file.size / 1024 / 1024 < pimgSize;
                if (!isLt2M) {
                    this.$message.error('上传照片大小不能超过 ' + pimgSize + ' MB!');
                    return isLt2M;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "上传中，请稍等...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
            },
            handleFileSuccess(res) {
                this.loading.close();
                dealResult(res);
                if (res.status == 1) {
                    this.$message.success('上传成功');
                    this.pimg = res.obj;

                } else {
                    this.dataForm.pimg = '';
                    this.$message.error('上传失败');
                }

            },



            saveEdit() {
                this.dataForm.id = this.lander.id;

                this.$refs.dataForm.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {
                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;
                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中，请稍等...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        editMyUinfo(this.dataForm).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success("已保存");
                                this.getinfo();
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })
                    }
                })
            },
            saveEditR() {


                this.$refs.dataFormR.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {
                        this.dataFormR.uid = this.lander.uid;
                        this.dataFormR.token = this.lander.token;
                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;

                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中，请稍等...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });


                        editUname(this.dataFormR).then((res) => {
                            this.loading.close()
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg)
                                this.getinfo();
                                localStorage.uname=this.dataFormR.uname;
                                this.$store.dispatch('saveUname',res.data.obj.uname);
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })
                    }
                })
            },
            getinfo() {
                getMyUserinfo({uid: this.lander.uid, token: this.lander.token}).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.canEditTs = res.data.obj.canEditTs;
                        this.editUnameDay = res.data.obj.editUnameDay;
                        this.canEditUname = res.data.obj.canEditUname;

                        this.dataFormR.uname = res.data.obj.user.uname;

                        this.dataForm.rname = res.data.obj.user.rname;
                        this.dataForm.mobile = res.data.obj.user.mobile;
                        this.dataForm.quhaoMobile = res.data.obj.user.quhaoMobile;
                        this.dataForm.countryMobile = res.data.obj.user.countryMobile;
                        this.dataForm.address = res.data.obj.user.address;
                        this.dataForm.qcountryMobile = res.data.obj.user.countryMobile + res.data.obj.user.quhaoMobile;

                        this.pimg = res.data.obj.user.pimg;

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },

            fixedmenu(){
                let JfLeftMenu=document.getElementById('JfLeftMenu');


                let that=this;

                window.onscroll = function () {
                    let t = document.documentElement.scrollTop || document.body.scrollTop;

                    that.LeftMenuWidth=JfLeftMenu.offsetWidth;
                    let LeftTop=JfLeftMenu.offsetTop;

                    if(t>LeftTop){
                        that.fixedleftmenu=true;
                    }else{
                        that.fixedleftmenu=false;
                    }



                }
            },
        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            if( this.webW) this.fixedmenu();

            if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
            if(document.body!=undefined) document.body.scrollTop=0;

            this.lander = JSON.parse(this.$store.state.logininfo);
            this.getinfo();

            this.qcountryMobileLi = qcountryMobileLi;
            this.dataForm.qcountryMobile = qcountryMobileLi[0].name + qcountryMobileLi[0].value;
            this.dataForm.countryMobile = qcountryMobileLi[0].name;
            this.dataForm.quhaoMobile = qcountryMobileLi[0].value;

            this.pimgSize = pimgSize;

            this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/common/upimg?type=mypimg&uid=' + this.lander.uid + "&token=" + this.lander.token;


            this.faceimg=this.lander.faceimg;
            this.FILE_ACTIONTX=process.env.VUE_APP_API_ROOT+'/common/upimg?type=faceimg&uid='+this.lander.uid+"&token="+this.lander.token;

        } , activated() {



            //固定左右菜单
            this.fixedmenu();


        },
        deactivated() {

        }
    };
</script>
<style scoped>

    .inpw {
        max-width: 300px;
    }

    .inptip {
        margin-left: 10px;
        color: #888888;
        font-size: 12px;

    }
    /deep/ .el-upload-dragger{width: 300px;}
    /ddep/ .el-upload--text{width: 300px;}

   /deep/ input[type=file]{display: none;}
</style>
